const parseToJson = (jsonObj) => {
  try {
    return JSON.parse(jsonObj)
  } catch (e) {
    console.error(e)
    return []
  }
}

export { parseToJson }
